export default class apiResult {
    constructor(success, data) {
        this.success = success;
        this.data = data;
    }
}
